const getGa4ClientId = () => {
  const gaCookie = (document.cookie || '')
    .split('; ')
    .find((row) => row.startsWith('_ga='));
  if (gaCookie) {
    const parts = gaCookie.split('.');
    return parts.length > 2 ? parts[2] + '.' + parts[3] : '';
  }
  return '';
};

const getTdClientId = () => {
  const tdCookie = (document.cookie || '')
    .split('; ')
    .find((row) => row.startsWith('_td='));
  return tdCookie ? tdCookie.substring('_td='.length) : '';
};

export const getAdsTracking = () => ({
  utm_source: window._utm_source,
  utm_medium: window._utm_medium,
  utm_campaign_id: window._utm_campaign_id,
  utm_adgroup_id: window._utm_adgroup_id,
  utm_ad_id: window._utm_ad_id,
  gclId: window._gclid,
  fbclid: window._fbclid,
  ttclid: window._ttclid,
  userId: getTdClientId(),
  gaId: getGa4ClientId(),
});

export const getSkipCallCenter = () => {
  const payload: { skipCallCenter?: boolean } = {};
  const sources = ['performancemax'];

  if (sources.includes(window._utm_source)) {
    payload.skipCallCenter = false;
  }

  return payload;
};
